import { View, Text, StyleSheet } from "@react-pdf/renderer";

import { ReportTimeRangeType, ReportPDFSummaryInfo } from "types/Reports";

import ReportPDFSummaryCard from "./ReportPDFSummaryCard";

const summaryStyles = StyleSheet.create({
    summary: {
        position: 'relative',
        fontFamily: 'Roboto',
        marginTop: 15,
    },
    summaryTitle: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 500,
        width: '80%',
        color: '#333333',
    },
    summaryCardContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginTop: 10,
        justifyContent: 'space-between',
        alignContent: 'space-between',
    },
});

type SummaryProps = {
    timeRangeType: ReportTimeRangeType;
    summaryInfo: ReportPDFSummaryInfo;
};

const ReportPDFSummary = ({
    timeRangeType,
    summaryInfo,
}: SummaryProps) => {
    return (
        <View style={summaryStyles.summary}>
            <Text style={summaryStyles.summaryTitle}>Summary</Text>

            <View style={summaryStyles.summaryCardContainer}>
                <ReportPDFSummaryCard
                    itemType="room"
                    timeRangeType={timeRangeType}
                    info={summaryInfo.room}
                />

                <ReportPDFSummaryCard
                    itemType="energy"
                    timeRangeType={timeRangeType}
                    info={summaryInfo.energy}
                />
            </View>

            <View style={summaryStyles.summaryCardContainer}>
                <ReportPDFSummaryCard
                    itemType="water"
                    timeRangeType={timeRangeType}
                    info={summaryInfo.water}
                />

                <ReportPDFSummaryCard
                    itemType="waterLeakage"
                    timeRangeType={timeRangeType}
                    info={summaryInfo.waterLeakage}
                />
            </View>
        </View>
    );
};

export default ReportPDFSummary;
